
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import VideoBufferRegionSelectorView from "views/audioEditor/VideoBufferRegionSelectorView";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import PlayerService from "services/PlayerService";
import PersistentModels from "services/PersistentModels";
import FileUploadHelper from "models/helper/FileUploadHelper";
import Utils from "models/helper/Utils";
import RSVP from "rsvp";

const VideoBufferRegionSelectorController = Chaplin.Controller.extend({

		initialize : function(options) {
			this.model =  options.videoSegmentJson;
			this.videoUniqueId = options.videoUniqueId;
			this.videoType = options.videoType;
			this.sequencerSettings = options.sequencerSettings;
			this._onRegionChangeSaved = options.onRegionChangeSaved;
			_.extend(this, Backbone.Events);
		},

		getModel : function() {
			return this.model;
		},

		getView : function() {
			return this.view;
		},

		_onSaveTrimButtonClicked : function(){
			if(this._onRegionChangeSaved){
				this._onRegionChangeSaved(true);
			}
		},

		getStartTime : function(){
			if (!this.view) return null;
			return this.view.getStartTime();
		},

		getEndTime : function(){
			if (!this.view) return null;
			return this.view.getEndTime();
		},

		stopPlayback : function(){
			if (!this.view) return;
			return this.view.stopPlayback();
		},

		destroyVideoInstance : function(){
			if (!this.view) return;
			this.view.destroy();
		},

		renderVideo : function(){
			if (!this.view) {
				throw new Error('View not initialized. Call buildModelAndRenderView first.');
			}
			this.view.renderVideo();
		},

		buildModelAndRenderView : function() {
			return new RSVP.Promise((function(resolve, reject) {
				try {

					const params = {};
					params.model = this.model ;
					params.videoUniqueId = this.videoUniqueId;
					params.videoType = this.videoType;
					params.sequencerSettings = this.sequencerSettings;

					this.view = new VideoBufferRegionSelectorView(params);
					this.view.render();
					this.listenTo(this.view , "saveTrim", this._onSaveTrimButtonClicked.bind(this));

					resolve();


				} catch (error) {
					reject(error);
				}

			}).bind(this));

		}

});

export default VideoBufferRegionSelectorController;
